export default __webpack_public_path__ + "static/media/cart.ece69dec.svg";